<template>
  <div class="main-layout">
    <navbar/>
    <sidebar/>
    <div class="page">
      <div class="page-content p-3">
        <child/>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from '~/components/Navbar'
  import Sidebar from '~/components/Sidebar'

  export default {
    name: 'MainLayout',

    components: {
      Navbar,
      Sidebar
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/layouts/default.vue